import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Injectable } from '@angular/core';
import { InscricaoEstadual } from 'src/validators/inscricao-estadual/ie';

@Injectable({ providedIn: 'root' })
export class InscricaoEstadualValidator {
  // Estados que possuem validação específica (adicionar o estado aqui para adicionar a mensagem customizada no campo)
  private static readonly STATES_WITH_SPECIFIC_VALIDATION = ['BA', 'PA'];
  
  static stateLengths: Record<string, number> = {
    BA: 9, 
    PA: 9, 
  };

  static hasSpecificValidation(uf: string): boolean {
    return this.STATES_WITH_SPECIFIC_VALIDATION.includes(uf.toUpperCase());
  }

  static validateSpecificState(control: AbstractControl, uf: string): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value || !uf) return null;

    const numericValue = value.replace(/[^\d]/g, '');
    const isValidFormat = /^[\d.\-]+$/.test(value);
    const ufUpper = uf.toUpperCase();

    const expectedLength = this.stateLengths[ufUpper];
    const isValidLength = expectedLength ? numericValue.length === expectedLength : true;

    const isValid = InscricaoEstadual.InscricaoEstadualValid(value, ufUpper);

    // Erro de quantidade de dígitos
    if (!isValidFormat || !isValidLength) {
      return {
        'invalid-inscricao-estadual': {
          type: 'InvalidFormatInscricaoEstadual',
          uf
        }
      };
    }

    // Erro de dígito verificador
    if (!isValid) {
      return {
        'invalid-inscricao-estadual': {
          type: 'InvalidInscricaoEstadual',
          uf
        }
      };
    }

    return null;
  }

  static validateDefaultState(control: AbstractControl, uf: string): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value || !uf) return null;

    const isValid = InscricaoEstadual.InscricaoEstadualValid(value, uf.toUpperCase());
    
    if (!isValid) {
      return { 'invalid': true };
    }

    return null;
  }

  static validate(control: AbstractControl, uf: string): ValidationErrors | null {
    if (this.hasSpecificValidation(uf)) {
      return this.validateSpecificState(control, uf);
    } else {
      return this.validateDefaultState(control, uf);
    }
  }
}